import { Modal, Typography } from 'antd'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { useAppStore } from '../../stores/app'
import { DatoAssets } from '../Assets'
import { ModalProps } from './types'

const Title = styled(Typography.Title).attrs({ level: 4 })`
  margin-top: 0;
`

export function ReleaseInfo({ isVisible, params, onCancel }: ModalProps): React.ReactNode {
  const [releaseInfo] = useAppStore((state) => [state.releaseInfo])

  const currentRelease = releaseInfo?.find((info) => info.id === params?.releaseId)
  if (!currentRelease) return null
  const { title, content, releaseDate } = currentRelease

  return (
    <Modal
      open={isVisible}
      onCancel={onCancel}
      maskClosable={false}
      title={dayjs(releaseDate).format('MMMM D')}
      footer={null}
      width={700}
      centered
      styles={{
        body: {
          maxHeight: '80vh',
          overflowY: 'auto',
        },
      }}
    >
      <Title level={3}>{title}</Title>
      <DatoAssets assets={content} />
    </Modal>
  )
}
